import api from "../../../../Api/feathers-client";

// Call backend service to create users
export const createEmployeePayrollApprover = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("hr-employee-payroll-approvers").create(data, {});
      resolve({
        status: 201,
        message: "Leave Type Created",
        data: response,
      });
    } catch (error) {
      console.log("error===>", error);
      resolve(error);
    }
  });
};

// Call backend service to update users
export const updateEmployeePayrollApprover = async (data, uid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("hr-employee-payroll-approvers").patch(null, data, {
        query: {
          uid,
        },
      });

      resolve({
        status: 201,
        message: "Departments Updated",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

export const getEmployeePayrollApproversDb = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("hr-employee-payroll-approvers").find(params);
      resolve({
        status: 201,
        message: "Employee Payroll Approvers List",
        data: response,
      });
    } catch (error) {
      console.log("error==>", error);
      resolve(error);
    }
  });
};
